"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var axios_1 = __importDefault(require("axios"));
var Lang_1 = require("../Lang");
var Box_1 = __importDefault(require("@mui/material/Box"));
var Typography_1 = __importDefault(require("@mui/material/Typography"));
var mountIsland_1 = require("../mountIsland");
var FALLBACK_IMAGE = "https://www.msia.org/wp-content/uploads/2017/12/top_10_ndh_2017_1080800.jpg";
function GetASeminar() {
    var _a;
    var _b = (0, react_1.useState)(null), requestSeminar = _b[0], setSeminar = _b[1];
    (0, react_1.useEffect)(function () {
        var id = window.location.pathname.split("/").pop();
        axios_1.default
            .get("/app/seminars/info/" + id)
            .then(function (response) {
            setSeminar(response.data);
        })
            .catch(function (error) {
            console.log(error);
        });
    }, []);
    if (!requestSeminar)
        return null;
    return (react_1.default.createElement(Box_1.default, { className: "container" },
        react_1.default.createElement(Typography_1.default, { variant: "inherit", component: "h2" }, requestSeminar.title),
        react_1.default.createElement(Box_1.default, { component: "img", src: (_a = requestSeminar.image) !== null && _a !== void 0 ? _a : FALLBACK_IMAGE, className: "seminar-featured-image", alt: requestSeminar.title }),
        react_1.default.createElement(Box_1.default, { sx: { display: "flex", gap: 2, flexWrap: "wrap" } },
            react_1.default.createElement(Box_1.default, { sx: { flex: 1 } },
                react_1.default.createElement(Typography_1.default, null,
                    react_1.default.createElement("strong", null,
                        (0, Lang_1.__)("Description"),
                        ":"),
                    " ",
                    requestSeminar.description),
                react_1.default.createElement(Typography_1.default, null,
                    react_1.default.createElement("strong", null,
                        (0, Lang_1.__)("Contact Info"),
                        ":"),
                    " ",
                    requestSeminar.contact),
                react_1.default.createElement(Typography_1.default, null,
                    react_1.default.createElement("strong", null,
                        (0, Lang_1.__)("Frequency"),
                        ":"),
                    " ",
                    requestSeminar.frequency),
                react_1.default.createElement(Typography_1.default, null,
                    react_1.default.createElement("strong", null,
                        (0, Lang_1.__)("Duration"),
                        ":"),
                    " ",
                    requestSeminar.duration)),
            react_1.default.createElement(Box_1.default, { sx: { flex: 1 } },
                react_1.default.createElement(Typography_1.default, null,
                    react_1.default.createElement("strong", null,
                        (0, Lang_1.__)("Language"),
                        ":"),
                    " ",
                    requestSeminar.language),
                react_1.default.createElement(Typography_1.default, null,
                    react_1.default.createElement("strong", null,
                        (0, Lang_1.__)("Location"),
                        ":"),
                    " ",
                    requestSeminar.city,
                    " ",
                    requestSeminar.state,
                    " ",
                    requestSeminar.country),
                react_1.default.createElement(Typography_1.default, null,
                    react_1.default.createElement("strong", null,
                        (0, Lang_1.__)("Format"),
                        ":"),
                    " ",
                    requestSeminar.format),
                react_1.default.createElement(Typography_1.default, null,
                    react_1.default.createElement("strong", null,
                        (0, Lang_1.__)("Timezone"),
                        ":"),
                    " ",
                    requestSeminar.timezone)))));
}
exports.default = GetASeminar;
var seminarInfoEl = document.getElementById("seminar-info");
if (seminarInfoEl) {
    (0, mountIsland_1.mountIsland)(seminarInfoEl, react_1.default.createElement(GetASeminar, null));
}
